export default "__VITE_ASSET__CJFeQKA5__"